/* Quiz « Trouvez la pierre qui vous correspond » — page trouver-ma-pierre.
   Voir docs/chantier-quiz-pierre.md et sections/quiz-pierre.liquid.

   CHAINE : reponses -> pierres classees -> produits qui contiennent ces pierres.
   Aucune liste de produits ici : elle est lue en direct sur
   /collections/all?view=quiz-pierres, donc un produit publie avec ses pierres
   reliees au metaobjet entre tout seul dans les recommandations.

   Style volontairement aligne sur assets/recherche-pierres.js (IIFE, var,
   fonctions nommees) : meme page, meme maison.

   ⚠️ La regle de score DOIT rester identique a celle de scripts/qa_quiz_pierre.py,
   qui la verifie sur tous les parcours. Modifier l'une = modifier l'autre. */
(function () {
  "use strict";

  var root = document.getElementById("mm-quiz");
  if (!root) return;

  var CACHE_KEY = "mm-quiz-index-v1";
  var stones = null;
  var config = null;
  var index = null;           // { pierre -> [produits] }, charge en arriere-plan
  var etat = { pas: 0, reponses: {}, ordre: [] };

  var el = {
    intro: root.querySelector('[data-mq-screen="intro"]'),
    quiz: root.querySelector('[data-mq-screen="quiz"]'),
    reveal: root.querySelector('[data-mq-screen="reveal"]'),
    result: root.querySelector('[data-mq-screen="result"]'),
    start: root.querySelector("[data-mq-start]"),
    duration: root.querySelector("[data-mq-duration]"),
    step: root.querySelector("[data-mq-step]"),
    barfill: root.querySelector("[data-mq-barfill]"),
    question: root.querySelector("[data-mq-question]"),
    help: root.querySelector("[data-mq-help]"),
    answers: root.querySelector("[data-mq-answers]"),
    back: root.querySelector("[data-mq-back]"),
    skip: root.querySelector("[data-mq-skip]"),
    out: root.querySelector("[data-mq-result]"),
    restart: root.querySelector("[data-mq-restart]"),
    error: root.querySelector("[data-mq-error]")
  };

  // ---------------------------------------------------------------- outils

  function norm(s) {
    return (s == null ? "" : String(s)).trim().toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "");
  }

  function esc(t) {
    return (t == null ? "" : String(t)).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function sobre() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  // Evenements exploitables si une couche analytics est branchee un jour.
  // ⚠️ Aujourd'hui la mesure du site est incomplete (banniere de consentement,
  // scope read_pixels absent) : ces evenements sont poses parce qu'ils coutent
  // dix lignes, pas parce qu'ils remontent quelque part des maintenant.
  function trace(nom, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: nom }, detail || {}));
      document.dispatchEvent(new CustomEvent(nom, { detail: detail || {} }));
    } catch (e) { /* jamais bloquant */ }
  }

  // Nom explicite : `q.montre` est un NOMBRE de reponses a afficher, sans rapport.
  function afficherEcran(nom) {
    ["intro", "quiz", "reveal", "result"].forEach(function (k) {
      if (el[k]) el[k].hidden = (k !== nom);
    });
  }

  // ------------------------------------------------------- chargement data

  // Une promesse qui echoue au bout de `ms` : AUCUN fetch de cette page n'a de
  // delai natif, et une requete pendante (reseau lent, proxy) ne passe jamais
  // par .catch → l'audit du 11/09 a reproduit un ecran de revelation affiche
  // pour toujours. Le delai transforme une attente infinie en repli.
  var DELAI_MS = 7000;
  function avecDelai(promesse, ms) {
    return new Promise(function (ok, ko) {
      var t = window.setTimeout(function () { ko(new Error("delai")); }, ms || DELAI_MS);
      promesse.then(function (v) { window.clearTimeout(t); ok(v); },
                    function (e) { window.clearTimeout(t); ko(e); });
    });
  }

  // Chargeur JSON PARTAGE entre les scripts de la page : le moteur
  // (recherche-pierres.js) et le quiz lisent les deux memes assets. Sans ce
  // memo, chacun lancait ses propres requetes (mesure : mm-stones.json et
  // mm-quiz-pierres.json demandes deux fois au chargement).
  window.MM_JSON = window.MM_JSON || {};
  function chargerJson(url) {
    if (!window.MM_JSON[url]) {
      window.MM_JSON[url] = fetch(url, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    }
    return window.MM_JSON[url];
  }

  avecDelai(Promise.all([chargerJson(root.dataset.stones), chargerJson(root.dataset.config)]))
    .then(function (res) {
      stones = res[0];
      config = res[1];
      prepare();
      if (el.start) el.start.hidden = false;
      if (el.duration) el.duration.hidden = false;
      reprendreUrl();
    }).catch(function () {
      if (el.error) el.error.hidden = false;
    });

  function prepare() {
    stones.forEach(function (s) {
      s._ints = (s.intention || []).map(norm);
    });
    config.besoins.forEach(function (b) {
      b.nkeys = (b.keys || []).map(norm);
    });
  }

  function besoinParLabel(label) {
    for (var i = 0; i < config.besoins.length; i++) {
      if (config.besoins[i].label === label) return config.besoins[i];
    }
    return null;
  }

  // ------------------------------------------- index produits (arriere-plan)

  // Charge /collections/all?view=quiz-pierres, pagine a 250. Lance au DEMARRAGE
  // du quiz, pas au chargement de la page : le visiteur repond pendant ce temps.
  // Memoise la PROMESSE et non le resultat : on appelle chargerIndex() au
  // demarrage du quiz puis a l'affichage du resultat, et la garde `if (index)`
  // ne fermait pas la course entre les deux (deux fetchs, deux ecritures).
  var indexEnCours = null;
  function chargerIndex() {
    if (index) return Promise.resolve(index);
    if (indexEnCours) return indexEnCours;
    indexEnCours = chargerIndexVraiment();
    return indexEnCours;
  }

  // Duree de vie du cache de session : un produit passe en brouillon pendant la
  // visite restait recommande jusqu'a la fermeture de l'onglet, et son lien
  // faisait 404. Quinze minutes bornent ce risque sans recharger a chaque etape.
  var CACHE_TTL_MS = 15 * 60 * 1000;

  function chargerIndexVraiment() {
    try {
      var cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (cache && cache.t && (Date.now() - cache.t) < CACHE_TTL_MS && cache.i) {
        index = cache.i;
        return Promise.resolve(index);
      }
    } catch (e) { /* navigation privee, stockage bloque : on refetch */ }

    var base = root.dataset.index;
    var lecture = fetch(base, { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var p1 = JSON.parse(t);
        var suite = [];
        for (var n = 2; n <= (p1.pages || 1); n++) {
          suite.push(fetch(base + "&page=" + n, { credentials: "same-origin" })
            .then(function (r) { return r.text(); })
            .then(function (x) { return JSON.parse(x).items || []; }));
        }
        return Promise.all(suite).then(function (restes) {
          var tous = (p1.items || []).slice();
          restes.forEach(function (lot) { tous = tous.concat(lot); });
          index = indexer(tous);
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), i: index })); } catch (e) { /* ok */ }
          return index;
        });
      });
    // Le delai couvre TOUTES les pages : au-dela, on sert le repli plutot que
    // de laisser « Nous croisons vos reponses » a l'ecran indefiniment.
    return avecDelai(lecture, DELAI_MS)
      .catch(function () {
        // Filet : le handle precalcule dans mm-stones.json (bracelet mono-pierre).
        // Le quiz ne rend jamais un ecran sans issue, il rend moins de choix.
        index = indexer(stones.filter(function (s) { return s.produit; }).map(function (s) {
          return { h: s.produit, n: s.nom, t: "", u: "/products/" + s.produit,
                   a: true, prix: "", prix_min: 0, multi: false, img: "", p: [s.handle] };
        }));
        return index;
      });
  }

  // Inverse la liste plate en { handle de pierre -> produits qui la contiennent }.
  function indexer(items) {
    var par = {};
    items.forEach(function (it) {
      (it.p || []).forEach(function (ph) {
        (par[ph] = par[ph] || []).push(it);
      });
    });
    return par;
  }

  // ------------------------------------------------------ score des pierres

  // Miroir exact de scripts/qa_quiz_pierre.py : intentions communes ponderees
  // par question, plus un bonus selon le rang dans la curation `top` du besoin.
  function scorePierre(s, besoin) {
    var total = 0;
    config.questions.forEach(function (q) {
      var poids = q.poids || 0;
      if (!poids) return;
      var rep = etat.reponses[q.id];
      if (!rep) return;
      var cibles = (rep.intentions || []).map(norm);
      if (!cibles.length && rep.besoin && besoin) cibles = besoin.nkeys;
      var communes = 0;
      cibles.forEach(function (c) { if (s._ints.indexOf(c) !== -1) communes++; });
      total += poids * communes;
    });
    if (besoin && besoin.top) {
      var rang = besoin.top.indexOf(s.handle);
      if (rang !== -1) {
        var b = config.bonus_curation || [];
        total += rang < b.length ? b[rang] : 1;
      }
    }
    return total;
  }

  function classement() {
    var rep = etat.reponses.intention;
    var besoin = rep && rep.besoin ? besoinParLabel(rep.besoin) : null;
    var exclues = (besoin && besoin.exclude) || [];
    var liste = stones.filter(function (s) {
      return exclues.indexOf(s.handle) === -1;
    }).map(function (s) {
      return { s: s, score: scorePierre(s, besoin) };
    });
    liste.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (a.s.nom || "").localeCompare(b.s.nom || "", "fr");
    });
    // Le coup de coeur passe la pierre choisie en tete : c'est LUI qui fait la
    // diversite des resultats (48 pierres possibles en principale, contre 14 sans),
    // le score seul laissant 11 % de parcours a egalite parfaite.
    var choix = etat.reponses.coeur && etat.reponses.coeur.pierre;
    if (choix) {
      for (var k = 0; k < liste.length; k++) {
        if (liste[k].s.handle === choix) {
          if (k > 0) liste.unshift(liste.splice(k, 1)[0]);
          break;
        }
      }
    }
    return liste;
  }

  // ------------------------------------------------------ score des produits

  // score = max(scores des pierres du produit)
  //       + coefficients_multi[0] x 2e meilleure + coefficients_multi[1] x 3e (puis 0)
  //         puis x priorite du type de produit.
  // PLAFONNE et non une somme : l'audit du 11/09 a montre qu'avec « + 0,5 x somme
  // des autres », cinq pierres a 5 (aucune pertinente) faisaient 15 et battaient
  // une mono-pierre parfaite a 10. Le score montait avec le NOMBRE de pierres.
  // Ici : 10/8/0 → 14 (deux bonnes pierres gagnent), 5x5 → 8,8, 7x4 → 7.
  // A score egal, le produit qui contient LE MOINS de pierres gagne : un bracelet
  // mono-pierre est une reponse plus ciblee qu'une creation qui contient la pierre.
  //
  // opts.seule   : ne compter QUE la pierre demandee (cartes secondaires). Sans ca,
  //                les scores globaux du profil faisaient remonter un Passage qui
  //                contient la pierre PRINCIPALE sous une carte secondaire :
  //                « Amethyste 39,90 € » menait a La Veilleuse (62 cartes sur 126).
  // opts.exclure : handles de produits deja proposes plus haut (12 cartes menaient
  //                au MEME produit que la principale).
  function produitsPour(handles, scores, opts) {
    opts = opts || {};
    var coefs = config.coefficients_multi || [0.5, 0.25];
    var prio = config.priorites_type || {};
    var vus = {};
    var out = [];
    handles.forEach(function (ph) {
      (index[ph] || []).forEach(function (it) {
        if (vus[it.h]) return;
        vus[it.h] = true;
        if (opts.exclure && opts.exclure[it.h]) return;
        var props = opts.seule
          ? [scores[ph] || 0]
          : (it.p || []).map(function (x) { return scores[x] || 0; }).sort(function (a, b) { return b - a; });
        var brut = props.length ? props[0] : 0;
        for (var i = 1; i < props.length && (i - 1) < coefs.length; i++) brut += coefs[i - 1] * props[i];
        var mult = prio[it.t] != null ? prio[it.t] : (prio.defaut != null ? prio.defaut : 1);
        out.push({ it: it, score: brut * mult, n: (it.p || []).length });
      });
    });
    out.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (a.n !== b.n) return a.n - b.n;
      return (a.it.n || "").localeCompare(b.it.n || "", "fr");
    });
    return out;
  }

  function disponibles(liste) {
    return liste.filter(function (x) { return x.it.a; });
  }

  // ----------------------------------------------------------- questionnaire

  // Familles montrees a la question d'intention : les plus pertinentes au vu de
  // l'etat declare, les autres repliees. Le classement est CALCULE (nombre de
  // pierres communes aux deux reponses) — aucun mapping ecrit a la main, donc
  // rien a maintenir quand les pierres changent. Une famille a 0 pierre commune
  // produirait un resultat qui ignore la premiere reponse : c'est celle-la qu'on
  // replie, ce n'est pas du rangement.
  function familiesTriees() {
    var rep = etat.reponses.etat;
    var q = questionPar("intention");
    if (!rep) return q.reponses.slice();
    var cibles = (rep.intentions || []).map(norm);
    var lot = stones.filter(function (s) {
      return cibles.some(function (c) { return s._ints.indexOf(c) !== -1; });
    });
    return q.reponses.slice().map(function (r) {
      var b = besoinParLabel(r.besoin);
      // Garde COMPLETE : sans elle, un `besoin` mal orthographie dans le JSON
      // leve une exception dans le gestionnaire de clic, AVANT l'affichage de
      // l'ecran. Le visiteur clique « Commencer » et rien ne se passe, sans
      // message. C'est la forme la plus pure du piege de rendu muet.
      if (!b || !b.nkeys) return { r: r, n: -1 };
      var exc = b.exclude || [];
      var n = lot.filter(function (s) {
        return exc.indexOf(s.handle) === -1
          && b.nkeys.some(function (k) { return s._ints.indexOf(k) !== -1; });
      }).length;
      return { r: r, n: n };
    }).sort(function (a, b) {
      if (b.n !== a.n) return b.n - a.n;
      return a.r.label.localeCompare(b.r.label, "fr");
    }).map(function (x) { return x.r; });
  }

  function questionPar(id) {
    for (var i = 0; i < config.questions.length; i++) {
      if (config.questions[i].id === id) return config.questions[i];
    }
    return null;
  }

  function rendreQuestion() {
    // Garde : le bouton Commencer est un `.button`, et Be Yours lui donne
    // display:flex, ce qui l'emporte sur [hidden]. Sans la regle CSS `.mq [hidden]`
    // il etait visible AVANT le chargement, et un clic levait une exception
    // muette ici (config null). La regle CSS corrige l'affichage ; cette garde
    // corrige le clic si jamais elle manquait.
    if (!config || !stones) return;
    var q = config.questions[etat.pas];
    if (!q) { terminer(); return; }

    el.question.textContent = q.question;
    el.help.textContent = q.aide || "";
    el.help.hidden = !q.aide;
    el.step.textContent = "Question " + (etat.pas + 1) + " sur " + config.questions.length;
    // La barre montre la question EN COURS (1/4 = 25 %), pas les questions faites :
    // a 0 % sur la premiere, elle n'indiquait rien.
    el.barfill.style.width = (((etat.pas + 1) / config.questions.length) * 100) + "%";
    el.back.hidden = etat.pas === 0;
    el.skip.hidden = !q.passer;
    // Vide le texte quand il n'y a rien a passer : il restait celui de la
    // question precedente et s'affichait dans le bouton fantome.
    el.skip.textContent = q.passer || "";

    if (q.type === "photos") rendrePhotos(q);
    else rendreChoix(q);

    afficherEcran("quiz");
    el.question.focus();
  }

  function rendreChoix(q) {
    var reponses = q.reponses;
    var replie = [];
    if (q.id === "intention" && q.montre && q.montre < reponses.length) {
      reponses = familiesTriees();
      replie = reponses.slice(q.montre);
      reponses = reponses.slice(0, q.montre);
    }
    var html = reponses.map(carteReponse).join("");
    if (replie.length) {
      html += '<button type="button" class="button button--tertiary button--small mq__more"'
        + ' data-mq-more>Voir les ' + replie.length + " autres</button>"
        + '<div class="mq__answers mq__answers--more" data-mq-morewrap hidden>'
        + replie.map(carteReponse).join("") + "</div>";
    }
    el.answers.innerHTML = html;
  }

  function carteReponse(r) {
    return '<button type="button" class="mq__answer" data-mq-answer="' + esc(r.id) + '">'
      + esc(r.label) + "</button>";
  }

  // Ecran du coup de coeur : les VRAIES photos des pierres de tete. Aucune famille
  // de couleurs n'est decrite, le catalogue n'expose aucune donnee de couleur
  // fiable (decision du 09/09) — on montre les pierres au lieu de les nommer.
  function rendrePhotos(q) {
    var n = parseInt(root.dataset.photos, 10) || 4;
    var tete = classement().slice(0, n);
    if (tete.length < 2) { suivant(); return; }
    el.answers.innerHTML = '<div class="mq__photos">'
      + tete.map(function (x) {
          var img = x.s.image
            ? '<img src="' + esc(x.s.image) + '" alt="' + esc(x.s.nom) + '" loading="lazy">'
            : '<span class="mq__photo-ph"></span>';
          return '<button type="button" class="mq__photo" data-mq-photo="' + esc(x.s.handle) + '">'
            + '<span class="mq__photo-img">' + img + "</span>"
            + '<span class="mq__photo-nom">' + esc(x.s.nom) + "</span></button>";
        }).join("")
      + "</div>";
  }

  function repondre(q, rep) {
    etat.reponses[q.id] = rep || {};
    if (etat.ordre.indexOf(q.id) === -1) etat.ordre.push(q.id);
    suivant();
  }

  function suivant() {
    etat.pas++;
    if (etat.pas >= config.questions.length) terminer();
    else rendreQuestion();
  }

  function terminer() {
    var delai = sobre() ? 0 : (parseInt(root.dataset.revealMs, 10) || 0);
    if (delai > 0) {
      afficherEcran("reveal");
      window.setTimeout(afficherResultat, delai);
    } else {
      afficherResultat();
    }
  }

  // ----------------------------------------------------------------- resultat

  function afficherResultat() {
    chargerIndex().then(function () {
      var liste = classement();
      var scores = {};
      liste.forEach(function (x) { scores[x.s.handle] = x.score; });

      // La pierre PRINCIPALE doit avoir un produit disponible, sinon le resultat
      // n'a pas d'issue. Les secondaires, non : une pierre seulement documentee
      // (doctrine asymetrique metaobjet/bracelet) peut sortir avec sa fiche.
      var principale = null;
      for (var i = 0; i < liste.length; i++) {
        if (disponibles(produitsPour([liste[i].s.handle], scores)).length) {
          principale = liste[i];
          break;
        }
      }
      if (!principale) principale = liste[0];
      if (!principale) { if (el.error) el.error.hidden = false; return; }

      var autres = liste.filter(function (x) {
        return x.s.handle !== principale.s.handle && x.score > 0;
      });
      autres = diversifier(principale.s, autres).slice(0, 2);

      // Les produits deja proposes pour la principale ne reviennent pas sous
      // une carte secondaire.
      var exclure = {};
      disponibles(produitsPour([principale.s.handle], scores)).slice(0, 2).forEach(function (x) {
        exclure[x.it.h] = true;
      });

      el.out.innerHTML = htmlPrincipale(principale, scores) + htmlAutres(autres, scores, exclure) + htmlUsage();
      afficherEcran("result");
      var titre = el.out.querySelector("h3");
      if (titre) titre.focus();
      ecrireUrl();
      trace("find_my_stone_completed", {
        pierre: principale.s.handle,
        score: principale.score,
        secondaires: autres.map(function (x) { return x.s.handle; }).join(","),
        reponses: etat.ordre.map(function (k) { return k + ":" + (etat.reponses[k].id || "-"); }).join("|")
      });
    });
  }

  // Une secondaire doit apporter une intention que la principale ne couvre pas,
  // sinon on propose trois fois la meme pierre sous trois noms.
  function diversifier(principale, liste) {
    var couvert = principale._ints.slice();
    var out = [];
    liste.forEach(function (x) {
      var neuf = x.s._ints.some(function (i) { return couvert.indexOf(i) === -1; });
      if (neuf) {
        out.push(x);
        x.s._ints.forEach(function (i) { if (couvert.indexOf(i) === -1) couvert.push(i); });
      }
    });
    // Si la diversite vide la liste (catalogue tres homogene sur ce besoin),
    // on reprend le classement brut plutot que de ne rien proposer.
    return out.length >= 2 ? out : liste;
  }

  // Les intentions REELLEMENT communes entre les reponses et la pierre. C'est la
  // version honnete du « 87 % de compatibilite » des quiz concurrents : un chiffre
  // invente, ici remplace par la raison nommee.
  function intentionsCommunes(s) {
    var rep = etat.reponses.intention;
    var besoin = rep && rep.besoin ? besoinParLabel(rep.besoin) : null;
    var cibles = [];
    config.questions.forEach(function (q) {
      if (!(q.poids || 0)) return;
      var r = etat.reponses[q.id];
      if (!r) return;
      var c = (r.intentions || []).map(norm);
      if (!c.length && r.besoin && besoin) c = besoin.nkeys;
      c.forEach(function (x) { if (cibles.indexOf(x) === -1) cibles.push(x); });
    });
    return (s.intention || []).filter(function (i) {
      return cibles.indexOf(norm(i)) !== -1;
    });
  }

  function phrasePerso(s) {
    var f = config.fragments;
    var bouts = [];
    var re = etat.reponses.etat, ri = etat.reponses.intention;
    if (re && f.etat[re.id]) bouts.push(f.etat[re.id]);
    if (ri && f.intention[ri.id]) bouts.push(f.intention[ri.id]);
    var phrase = bouts.join(" ");
    if (phrase) phrase = phrase.charAt(0).toUpperCase() + phrase.slice(1) + ".";
    return phrase;
  }

  function htmlPrincipale(x, scores) {
    var s = x.s;
    var prods = disponibles(produitsPour([s.handle], scores));
    var communes = intentionsCommunes(s);
    var html = '<p class="caption-with-letter-spacing">Votre pierre principale</p>'
      + '<div class="mq__hero">'
      + '<div class="mq__hero-img">'
      + (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.nom) + '">' : "")
      + "</div>"
      + '<div class="mq__hero-txt">'
      + '<h3 class="h1" tabindex="-1">' + esc(s.nom) + "</h3>";

    var perso = phrasePerso(s);
    if (perso) html += '<p class="mq__perso typeset2">' + esc(perso) + "</p>";
    if (s.en_bref) html += '<p class="mq__bref typeset2">' + esc(s.en_bref) + "</p>";
    if (communes.length) {
      html += '<p class="mq__match">Vos réponses et cette pierre se rejoignent sur&nbsp;: '
        + communes.map(function (i) { return esc(i.trim()); }).join(" · ") + "</p>";
    }
    html += htmlProduits(prods, s);
    html += '<a class="mq__fiche" href="/pages/pierre/' + esc(s.handle) + '">'
      + "Lire la fiche de cette pierre</a>";
    return html + "</div></div>";
  }

  // Le prix vient du produit Shopify a chaque rendu de l'index : jamais ecrit en dur.
  // Nom des pierres d'un produit, pour expliquer un bijou a plusieurs pierres.
  function nomsPierres(handles) {
    var noms = [];
    (handles || []).forEach(function (h) {
      for (var i = 0; i < stones.length; i++) {
        // trim : deux metaobjets portent une espace de fin (« Nacre », « Agate
        // sardonyx »), ce qui donnait « Nacre  et Angelite » a l'ecran.
        if (stones[i].handle === h) { noms.push((stones[i].nom || "").trim()); return; }
      }
    });
    return noms;
  }

  // Libelle COURT d'un produit pour un bouton : la partie avant « · » du titre
  // Shopify. Le titre complet (« La Veilleuse · bracelet en amethyste, pierre de
  // lune blanche et lepidolite ») faisait deux lignes en capitales et redisait
  // la composition affichee juste dessous.
  function libelleCourt(titre) {
    return (titre || "").split(" · ")[0].trim();
  }

  function htmlProduits(prods, s) {
    if (!prods.length) {
      return '<p class="mq__meta">Cette pierre n’est pas montée en bracelet pour le moment.</p>';
    }
    var p = prods[0].it;
    var prix = p.prix ? (p.multi ? "à partir de " + p.prix : p.prix) : "";
    var html = "";
    // Photo du PRODUIT (l'index la transportait sans que rien ne l'affiche) :
    // quand la principale est un Passage, on vend un objet qu'il faut voir.
    if (p.img) {
      html += '<a class="mq__prod" href="' + esc(p.u) + '" data-mq-prod="' + esc(p.h) + '">'
        + '<img class="mq__prod-img" src="' + esc(p.img) + '" alt="' + esc(libelleCourt(p.n)) + '" loading="eager">'
        + "</a>";
    }
    html += '<a class="button mq__cta" href="' + esc(p.u) + '" data-mq-prod="' + esc(p.h) + '">'
      + esc(libelleCourt(p.n)) + (prix ? "&nbsp;· " + esc(prix) : "") + "</a>";
    // Un bijou a plusieurs pierres peut remonter devant le mono-pierre (c'est le
    // score de compatibilite). Il faut alors DIRE pourquoi on le propose, sinon
    // l'ecran annonce une pierre et vend un objet qui porte un autre nom.
    // Tournure sans article : « Il associe la lépidolite et l'améthyste » exigerait
    // de connaitre le genre de 84 noms de pierres. Les deux-points l'evitent et
    // restent lisibles.
    var noms = nomsPierres(p.p);
    if (noms.length > 1) {
      html += '<p class="mq__compo">Il réunit ' + noms.length + " pierres&nbsp;: "
        + esc(noms.join(", ").replace(/,([^,]*)$/, " et$1")) + ".</p>";
    }
    if (prods.length > 1) {
      var q = prods[1].it;
      html += '<a class="mq__aussi" href="' + esc(q.u) + '" data-mq-prod="' + esc(q.h) + '">'
        + "Voir aussi&nbsp;: " + esc(libelleCourt(q.n)) + (q.prix ? " (" + esc(q.prix) + ")" : "") + "</a>";
    }
    return html;
  }

  function htmlAutres(autres, scores, exclure) {
    if (!autres.length) return "";
    exclure = exclure || {};
    // « D’autres » et non « Deux autres » : la liste est un slice(0, 2) qui peut
    // n'en rendre qu'une seule quand le catalogue est pauvre sur ce besoin.
    return '<p class="caption-with-letter-spacing mq__sep">D’autres pierres à explorer</p>'
      + '<div class="mq__others">'
      + autres.map(function (x) {
          var s = x.s;
          // Score sur CETTE pierre seule, et jamais un produit deja propose :
          // la carte « Amethyste » mene au bracelet en amethyste, pas au Passage
          // qui contient la principale.
          var prods = disponibles(produitsPour([s.handle], scores, { seule: true, exclure: exclure }));
          var p = prods.length ? prods[0].it : null;
          if (p) exclure[p.h] = true;
          var lien = p ? p.u : "/pages/pierre/" + s.handle;
          return '<a class="mq__other" href="' + esc(lien) + '"'
            + (p ? ' data-mq-prod="' + esc(p.h) + '"' : "") + ">"
            + '<span class="mq__other-img">'
            + (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.nom) + '" loading="lazy">' : "")
            + "</span>"
            + '<span class="mq__other-nom">' + esc(s.nom) + "</span>"
            + '<span class="mq__other-prix">'
            + (p && p.prix ? (p.multi ? "à partir de " + esc(p.prix) : esc(p.prix)) : "Voir la fiche")
            + "</span></a>";
        }).join("")
      + "</div>";
  }

  function htmlUsage() {
    var r = etat.reponses.usage;
    if (!r || !r.id) return "";
    var f = config.fragments;
    var txt = f.usage[r.id];
    var sortie = r.sortie && f.sorties[r.sortie];
    // La sortie « mono » pointe vers la collection que le bloc « Ce n'est pas
    // tout a fait ca ? » propose deja quelques centimetres plus bas : on garde
    // la phrase, pas le bouton en double.
    if (r.sortie === "mono") sortie = null;
    if (!txt && !sortie) return "";
    return '<div class="mq__usage">'
      + (txt ? '<p class="typeset2">' + esc(txt) + "</p>" : "")
      + (sortie ? '<a class="button button--secondary" href="' + esc(sortie.url) + '">'
          + esc(sortie.titre) + "</a>" : "")
      + "</div>";
  }

  // ------------------------------------------------------------- URL partage

  // Rend le resultat adressable : un lien envoye par message rejoue les memes
  // reponses. Sert aussi de retour arriere navigateur sans perdre le parcours.
  function ecrireUrl() {
    try {
      var p = etat.ordre.map(function (k) {
        return k + "-" + (etat.reponses[k].id || "");
      }).filter(function (x) { return x.slice(-1) !== "-"; }).join(".");
      if (!p) return;
      // On CONSERVE les parametres existants : ecraser toute la query ferait
      // perdre un ?utm_source=interne, seul moyen d'isoler le trafic interne
      // (Shopify n'a aucune exclusion par IP). Cf. docs/suivi-indicateurs.md
      var params = new URLSearchParams(window.location.search);
      params.set("quiz", p);
      history.replaceState(null, "", window.location.pathname + "?" + params.toString());
    } catch (e) { /* pas bloquant */ }
  }

  function reprendreUrl() {
    var m = /[?&]quiz=([^&]+)/.exec(window.location.search);
    if (!m) return;
    var parts = decodeURIComponent(m[1]).split(".");
    var ok = false;
    parts.forEach(function (bout) {
      var i = bout.indexOf("-");
      if (i < 1) return;
      var qid = bout.slice(0, i), rid = bout.slice(i + 1);
      var q = questionPar(qid);
      if (!q) return;
      if (q.type === "photos") {
        etat.reponses[qid] = { id: rid, pierre: rid };
        etat.ordre.push(qid); ok = true;
        return;
      }
      var rep = (q.reponses || []).filter(function (r) { return r.id === rid; })[0];
      if (!rep) return;
      etat.reponses[qid] = rep;
      etat.ordre.push(qid);
      ok = true;
    });
    if (!ok) return;
    etat.pas = config.questions.length;
    chargerIndex();
    afficherResultat();
  }

  // ------------------------------------------------------------- interactions

  if (el.start) {
    el.start.addEventListener("click", function () {
      etat = { pas: 0, reponses: {}, ordre: [] };
      chargerIndex();                    // en arriere-plan, pendant qu'il repond
      trace("find_my_stone_started", {});
      rendreQuestion();
    });
  }

  el.answers.addEventListener("click", function (e) {
    var q = config.questions[etat.pas];
    if (!q) return;

    var more = e.target.closest("[data-mq-more]");
    if (more) {
      var wrap = el.answers.querySelector("[data-mq-morewrap]");
      if (wrap) { wrap.hidden = false; more.hidden = true; }
      return;
    }

    var photo = e.target.closest("[data-mq-photo]");
    if (photo) {
      var h = photo.getAttribute("data-mq-photo");
      repondre(q, { id: h, pierre: h });
      return;
    }

    var btn = e.target.closest("[data-mq-answer]");
    if (!btn) return;
    var id = btn.getAttribute("data-mq-answer");
    var rep = (q.reponses || []).filter(function (r) { return r.id === id; })[0];
    if (rep) repondre(q, rep);
  });

  el.back.addEventListener("click", function () {
    if (etat.pas === 0) return;
    etat.pas--;
    var q = config.questions[etat.pas];
    if (q) {
      delete etat.reponses[q.id];
      var i = etat.ordre.indexOf(q.id);
      if (i !== -1) etat.ordre.splice(i, 1);
    }
    rendreQuestion();
  });

  el.skip.addEventListener("click", function () {
    var q = config.questions[etat.pas];
    if (q) repondre(q, {});
  });

  if (el.restart) {
    el.restart.addEventListener("click", function () {
      etat = { pas: 0, reponses: {}, ordre: [] };
      try { history.replaceState(null, "", window.location.pathname); } catch (e) { /* ok */ }
      rendreQuestion();
    });
  }

  // Un clic produit depuis le resultat : la seule mesure vraiment commerciale.
  root.addEventListener("click", function (e) {
    var a = e.target.closest("[data-mq-prod]");
    if (a) trace("find_my_stone_product_clicked", { produit: a.getAttribute("data-mq-prod") });
  });
})();
